module.exports = __webpack_public_path__ + "img/ic_share_tt.23028c9.png";